'use strict';

import { createVueInstance } from './helpers/vue-instance';

createVueInstance({
	el: '[data-init="locationfinder"]',
	delimiters: ['$({', '})'],
	data: {
		entries: [],
		tags: [],
		newTags: [],
		query: null,
		pageNumber: 1 // BE is already displaying page 0
	},
	methods: {
		getTags: function() {
			// get active tags from the url
			// some.url/tags/tag1,tag2,tag3?param=lorem => [tag1, tag2, tag3]
			this.tags = window.location.href.match(/\/tags\/([^?#\/]*)/);

			if (this.tags) {
				this.tags = this.tags[1].split(',');
				this.newTags = this.newTags.concat(this.tags); // duplicate tags array for further manipulation
			}
		},

		getQuery: function() {
			// get active 'query' parameter from the url
			this.query = window.location.search.split('query=')[1] || null;

			if (this.query) {
				this.query = this.query.split('&')[0];
			}
		},

		getEntries: function() {
			if ((this.newTags.length > 0) && this.tags) {
				window.location.pathname = window.location.pathname.replace('/tags/' + this.tags.toString(), '/tags/' + this.newTags.toString());
			} else if ((this.newTags.length > 0) && !this.tags) {
				window.location.pathname = window.location.pathname + '/tags/' + this.newTags.toString();
			} else if ((this.newTags.length === 0) && this.tags) {
				window.location.pathname = window.location.pathname.replace('/tags/' + this.tags.toString(), '');
			}
		},

		toggleTag: function(event) {
			let tag = event.currentTarget,
				tagName = tag.dataset.tagUrlName;

			if (this.newTags.indexOf(tagName) === -1) {
				this.newTags.push(tagName);
				tag.classList.remove('tags__tag--inactive');
			} else {
				this.newTags = this.newTags.filter(function(item) {
					return item !== tagName;
				});

				tag.classList.add('tags__tag--inactive');
			}
		},

		removeTag: function(event) {
			let tag = event.currentTarget,
				tagName = tag.dataset.tagUrlName;

			if (this.newTags.indexOf(tagName) !== -1) {
				this.newTags = this.newTags.filter(function(item) {
					return item !== tagName;
				});

				tag.classList.add('tags__tag--inactive');
			}

			this.getEntries(false);
		}
	},
	mounted: function() {
		this.getTags();
		this.getQuery();
	}
});
